export default __webpack_public_path__ + "static/media/avt-logo.2f87d3aa.svg";